import { Input as AriaInput, Label, Text, TextField, TextFieldProps } from 'react-aria-components';
import { cn } from '~/lib/utils';
import { CustomFieldError } from './Common';

export interface InputProps extends TextFieldProps {
  className?: string;
  classNameLabel?: string;
  classNameInput?: string;
  label?: string;
  description?: string;
  errorMessage?: string;
  isLocked?: boolean;
  startAdornment?: React.ReactNode | string;
  onChange?: (value: any) => void;
  placeholder?: string;
  endAdornment?: React.ReactNode | string;
}

// TODO
// - style disabled state

function Input({
  className,
  classNameLabel,
  classNameInput,
  label,
  description,
  errorMessage,
  isRequired,
  startAdornment,
  onChange,
  placeholder,
  endAdornment,
  ...props
}: InputProps) {
  return (
    <TextField
      {...props}
      className={cn('flex flex-col gap-1.5 w-full disabled:opacity-40', className)}
      isRequired={isRequired}
      isInvalid={!!errorMessage}
    >
      {!!label && (
        <Label className={cn('text-sm font-medium text-input-label', classNameLabel)}>
          {label} {isRequired && '*'}
        </Label>
      )}

      <div className="relative w-full items-center flex justify-center">
        {startAdornment && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 flex items-center gap-3">
            {startAdornment}
            <div className="h-6 border border-input-border" />
          </div>
        )}
        <AriaInput
          className={cn(
            'min-h-12 bg-input-background border border-input-border rounded-xl px-4 py-3 w-full text-[15px]',
            'text-foreground focus:border-input-border-focused focus:shadow-input-focus focus-visible:outline-0 placeholder:text-input-placeholder disabled:text-gray-500',
            'data-invalid:border-error',
            'data-readonly:pointer-events-none',
            startAdornment && 'pl-16', // Adjust left padding if adornment exists
            classNameInput,
          )}
          placeholder={placeholder}
          onChange={onChange}
        />
        {endAdornment && <div className="absolute right-6">{endAdornment}</div>}
      </div>

      {description && <Text slot="description">{description}</Text>}
      <CustomFieldError errorMessage={errorMessage} />
    </TextField>
  );
}

export default Input;
